import React from 'react'
import { IconButton, Menu, MenuItem } from 'react-mdl'

import {
  insertTable,
  removeTable,
  insertColumn,
  removeColumn,
  insertRow,
  removeRow,
} from './Transforms'

function isSelectionInTable(state) {
  return state.document
    .getAncestors(state.anchorKey)
    .some(({ type }) => type === 'table')
}

let id = 0
export default ({ state, onChange }) => {
  const insideTable = isSelectionInTable(state)
  const handleClick = fn => () => onChange(fn(state.transform()).apply())
  const buttonId = id++
  return (
    <span style={{ position: 'relative' }}>
      <IconButton name="border_all" id={`table-buttons-editor-${buttonId}`} />
      <Menu target={`table-buttons-editor-${buttonId}`}>
        <MenuItem disabled={insideTable} onClick={handleClick(insertTable)}>
          Insert Table
        </MenuItem>
        <MenuItem disabled={!insideTable} onClick={handleClick(insertRow)}>
          Insert Row below
        </MenuItem>
        <MenuItem disabled={!insideTable} onClick={handleClick(insertColumn)}>
          Insert Column right
        </MenuItem>
        <MenuItem disabled={!insideTable} onClick={handleClick(removeRow)}>
          Delete Row
        </MenuItem>
        <MenuItem disabled={!insideTable} onClick={handleClick(removeColumn)}>
          Delete Column
        </MenuItem>
        <MenuItem disabled={!insideTable} onClick={handleClick(removeTable)}>
          Delete Table
        </MenuItem>
      </Menu>
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Table/TableButtons.js